import { getTranslatedString } from 'helpers/i18n';

export const VEHICLE_TYPES = [
  { value: 'Car', primaryText: getTranslatedString('landlordPortal.vehicles.car') },
  { value: 'Truck', primaryText: getTranslatedString('landlordPortal.vehicles.truck') },
  { value: 'SUV', primaryText: getTranslatedString('landlordPortal.vehicles.suv') },
  { value: 'Electric Car', primaryText: getTranslatedString('landlordPortal.vehicles.electricCar') },
  { value: 'Motor Bike', primaryText: getTranslatedString('landlordPortal.vehicles.motorBike') },
  { value: 'Moped', primaryText: getTranslatedString('landlordPortal.vehicles.moped') },
  { value: 'Van', primaryText: getTranslatedString('landlordPortal.vehicles.van') },
  { value: 'Other', primaryText: getTranslatedString('landlordPortal.vehicles.other') },
];
